import React from "react"

const Nl2br = (string) => string.split('\n').map((item, index) => {
    return (index === 0) ? item : [<br key={index} />, item]
})

export default Nl2br